const Pagination = ({ currentPage, pageSize, totalPages, onPageChange }) => {
    const maxVisiblePages = 5;
    let pageNumbers = [];
  
    if (totalPages <= maxVisiblePages) {
      pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    } else {
      if (currentPage <= 3) {
        pageNumbers = Array.from({ length: maxVisiblePages }, (_, index) => index + 1);
      } else if (currentPage > totalPages - 3) {
        pageNumbers = Array.from({ length: maxVisiblePages }, (_, index) => totalPages - maxVisiblePages + index + 1);
      } else {
        pageNumbers = Array.from({ length: maxVisiblePages }, (_, index) => currentPage - 2 + index);
      }
    }
  
    return (
      <div className="pagination">
        <button
          className="primary prev-btn"
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          قبل
        </button>
        {currentPage > 3 && (
          <>
            <button className="primary" onClick={() => onPageChange(1)}>1</button>
            <span>...</span>
          </>
        )}
        {pageNumbers.map((page) => (
          <button
            key={page}
            className={`${currentPage === page ? "active" : ""} primary`}
            onClick={() => onPageChange(page)}
          >
            {page}
          </button>
        ))}
        {currentPage < totalPages - 2 && (
          <>
            <span>...</span>
            <button className="primary" onClick={() => onPageChange(totalPages)}>{totalPages}</button>
          </>
        )}
        <button
            className="primary next-btn"
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          بعد
        </button>
      </div>
    );
  };
  
  export default Pagination;
  